import './about.scss';
import Image2 from './../../images/photo2.webp';

const About: React.FC = () => {

  return (
      <>
          <section className={'about grid grid-cols-12 gap-6 flex flex-col bg-dark text-light px-6 py-6'}>
              {/*<div className='col-span-12 lg:col-span-10 lg:col-start-2'>
                  <img src={Image1} alt="" className='w-full hidden lg:block parallax'/>
                  <img src={Image1XS} alt="" className='w-full lg:hidden'/>
              </div>*/}
              <div className='col-span-12 gap-6 lg:col-span-4 lg:col-start-5'>
                  <img src={Image2} alt="" className='w-full'/>
              </div>
              <div className='col-span-12 gap-6  grid grid-cols-12 text-col'>
                <div className='col-span-12 lg:col-span-6 lg:col-start-5'>
                    <p className='text-1'>Born and raised in Milan, I started my career as a front-end developer before specializing in visual design, a field I've always been passionate about</p>
                </div>
                <div className='col-span-10 lg:col-span-5 lg:col-start-5'>
                    <p className='text-2 text-light-70'>I’m drawn to modern, clean aesthetics, yet I have a deep love for all things vintage. Films, music, old electronic devices, and vintage cameras all hold a special place in my heart</p>
                </div>
              </div>
              
          </section>
      </>
  );
};

export default About;